import React from "react";
import { SectionHeading } from "./ui";

const AREAS = [
  { name: "Los Angeles County", img: "https://images.pexels.com/photos/17445604/pexels-photo-17445604.jpeg" },
  { name: "Orange County", img: "https://images.pexels.com/photos/2680013/pexels-photo-2680013.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Southern California", img: "https://images.unsplash.com/photo-1768348256583-129b0cc812c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=940" },
  { name: "Nearby Communities", img: "https://images.pexels.com/photos/5223143/pexels-photo-5223143.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

export const ServiceAreas = () => (
  <section className="py-16 lg:py-24 bg-[#F5F5F5]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="Where We Serve"
        title="Serving Southern California"
        subtitle="Wallstreet Realty serves buyers, sellers, and licensed real estate agents throughout Southern California, including Los Angeles County, Orange County, and surrounding communities."
      />
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {AREAS.map((a) => (
          <div
            key={a.name}
            data-testid={`area-card-${a.name.toLowerCase().replace(/\s+/g, "-")}`}
            className="relative h-64 rounded-[20px] overflow-hidden group"
          >
            <img
              src={a.img}
              alt={a.name}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2D2D37]/85 via-[#2D2D37]/25 to-transparent" />
            <div className="absolute bottom-0 p-6">
              <h3 className="font-heading font-bold text-white text-xl">{a.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
